const messages = {
  title: "Liste de prețuri și broșuri de produse",
  title_media: "Liste de prețuri și broșuri de produse",
  description:
    "Descărcați aici cele mai recente broșuri și flyere despre anvelopele Bridgestone și Firestone pentru autoturisme, SUV-uri și autoutilitare.",
  short_description:
    "Aici puteți găsi materiale pentru social media, TV in-store și altele.",
  mediaCategories: {
    products: "Produse",
    brand_and_solutions: "Marcă și soluții",
    season_and_promotions: "Sezon și promoții",
    format: "Format",
    cars_and_vans: "Autoturism, SUV, utilitar",
    truck_and_buses: "Camion și autobuz",
    motorcycle: "Motocicletă",
    agriculture: "Agricultură",
    construction_machinery: "Utilaje de construcții",
    bridgestone: "Bridgestone",
    firestone: "Firestone",
    bandag: "Bandag",
    bleetcare: "Fleetcare",
    webfleet: "Webfleet",
    material: "Materiale",
    brochures: "Broșuri de produs",
    price_list: "Liste de prețuri",
    materials: "Materiale",
    video_in_store: "Video cu subtitrări",
    video_online: "Video fără subtitrări",
    video: "Video",
    banner_website: "Banner",
    banner_social_media: "Rețele sociale",
    logos: "Logo-uri",
    summer: "Vară",
    winter: "Iarnă",
    all_season: "Toate sezoanele",
    promotions: "Promoții",
    price: "Pricat",
  },
  mediasPage: {
    title: "BIBLIOTECA DE MEDII",
    description:
      "Bun venit în secțiunea de media dedicată   \n" +
      "produselor Bridgestone și Firestone.  \n <br> <br>" +
      "Veți descoperi imagini de produse,   \n" +
      "logo-uri, precum și o selecție largă de   \n" +
      "bannere, videoclipuri și materiale digitale   \n" +
      "de utilizat pe site-ul dvs. sau pe   \n" +
      "rețelele sociale.  ",
    bDrive: {
      title: "Fotografii produse",
      description:
        "Imaginile actuale   \n" +
        "pot fi descărcate   \n" +
        "de pe portalul nostru B-\n" +
        "DRIVE.  ",
    },
  },
  buttons: {
    media: "DESCOPERĂ",
  },
  searchMedia: "Introduceți un cuvânt cheie",
  searchResults: "Rezultatele căutării",
};

export default {
  messages,
};
